import { ReactElement } from 'react';
import { MenuCartItem } from 'platform/models/menu.types';
import styles from './OrderConfirmation.module.scss';

interface OrderItemCardProps {
  item: MenuCartItem;
}

export function OrderItemCard({ item }: OrderItemCardProps): ReactElement {
  return (
    <div className={styles.order_item_card}>
      <img src={item.imageURL} alt={item.title} className={styles.order_item_card_image} />
      <div className={styles.order_item_card_body}>
      <h3 className={styles.order_item_card_title}>{item.title}</h3>
      <div className={styles.order_item_card_meta}>
        {item.totalPrice && (
          <><strong>{item.totalPrice}</strong></>
        )}
        {[
          item.servingSize ? `${item.servingSize} Servings` : null,
          item.servingSize ? `Feeds ${item.servingSize}` : null,
          item.cookTime || null,
          item.cookTime && item.productType ? item.productType : null,
        ].filter(Boolean).map((detail) => (
          <span key={detail as string}>{'  •  '}{detail}</span>
        ))}
      </div>
      </div>
    </div>
  );
}
